import ApiFactory from '@fond-of/api-client'
import type { AccessToken } from '@fond-of/shop-api'

type LoginRequest = {
  email: string
  password: string
}

export enum ClientSessionKeys {
  TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY',
  TOKEN_PARAM_KEY = 'signature',
  CUSTOMER_UNIQUE_STORAGE_NAME = 'uuid',
  CUSTOMER_UNIQUE_HEADER = 'X-Anonymous-Customer-Unique-Id',
  CART_NAME = 'cart',
  CHECKOUT_ADDRESS_NAME = 'checkoutAddress',
  CHECKOUT_SUCCESS_NAME = 'checkoutSuccess',
  CHECKOUT_PAYMENT_NAME = 'checkoutPayment',
  CHECKOUT_TRIGGER_BEGIN = 'triggerBeginCheckout',
  CHECKOUT_LOGIN_CONFIRMED = 'loginConfirmed',
  CHECKOUT_GUEST_LOGIN_CONFIRMED = 'guestLoginConfirmed',
  AUTH_BLOCKED = 'blocked',
  AUTH_HIDE_WELCOME_BACK = 'hideWelcomeBack',
  SELECTED_PAYMENT_METHOD_NAME = 'selectedPaymentMethod',
}
const client = ApiFactory.new()
/**
 * Authenticates a user by sending login credentials to the server.
 *
 * @param {LoginRequest} loginRequest - The user's login credentials containing email and password
 * @returns {Promise<AccessToken>} A promise that resolves to an access token upon successful login
 * @throws {import('ky').HTTPError} If the request fails due to network issues, invalid credentials, or server problems
 */
export const login = async (
  loginRequest: LoginRequest
): Promise<AccessToken> => {
  const resp = await client
    .post('/api/auth/session', {
      uuid: true,
      json: loginRequest,
    })
    .json<AccessToken>()

  return resp
}

/**
 * Logs out the currently authenticated user.
 * @returns {Promise<void>} A promise that resolves when the user is successfully logged out
 * @throws {import('ky').HTTPError} If the request fails due to network issues or server problems
 */
export const logout = async () => {
  await client.delete('/api/auth/session')
}
